import { render, staticRenderFns } from "./shopPurchaseInfos.vue?vue&type=template&id=39149bd1"
import script from "./shopPurchaseInfos.vue?vue&type=script&lang=js"
export * from "./shopPurchaseInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports